export enum TranscriptError {
    NETWORK_ERROR = 'errorNetworkError',
    SERVER_OVERLOAD = 'errorServerOverload',
    INVALID_LINK = 'errorInvalidLink',
    ACCESS_DENIED = 'errorAccessDenied',
    TRANSCRIPT_NOT_FOUND = 'errorTranscriptNotFound',
    TECHNICAL_DIFFICULTIES = 'errorTechnicalDifficulties',
    /**
     * Error establishing connection in `TranscriptClient`, not necessarily a network error
     */
    CONNECTION_ERROR = 'errorConnectionError',
    /**
     * Additional error message for static links (navigation managed by platform)
     */
    INVALID_TOKEN = 'errorInvalidToken',
    /**
     * Additional error message for static links (navigation managed by platform)
     */
    NO_FUTURE_SESSIONS = 'errorNoFutureSessions',
    /**
     * User is accessing from wrong region, redirecting to correct region
     */
    REDIRECTING_TO_CORRECT_REGION = 'errorRedirectingToCorrectRegion',
    /**
     * Error processing uploaded document in Visor backend
     */
    DOCUMENT_PROCESSING_ERROR = 'errorDocumentProcessingError',
}
